import $ from 'jquery';
import 'jquery-validation';

jQuery(function ($) {
    var $forms = $('.beerloyuz-mail-form');
    if ($forms.length === 0) {
        $forms = $('[data-beerloyuz-mail]');
    }

    $forms.each(function () {
        var $form = $(this);
        var nonce = $form.find('input[name="_wpnonce"]').val() || '';

        var rules = {};
        var messages = {};

        var selectedLang = $form.attr('data-mail-lang') || 'tr';
        var buttonText = $form.attr('data-mail-button-text') || 'Submit';
        var buttonSubmittingText = $form.attr('data-mail-button-submitting-text') || 'Submitting...';

        $form.find('input[name], textarea[name], select[name]').each(function () {
            var $el = $(this);
            var name = $el.attr('name');

            if (!name || name.indexOf('_') === 0) {
                return;
            }
            if (!$el.is(':visible')) {
                return;
            }

            rules[name] = rules[name] || {};
            messages[name] = messages[name] || {};

            // Make message field never required
            if (name !== 'message' && name !== 'honeypot') {
                rules[name].required = true;
                if (selectedLang === 'tr') {
                    messages[name].required = "Bu alan zorunludur.";
                } else {
                    messages[name].required = "This field is required.";
                }
            }

            var type = ($el.attr('type') || '').toLowerCase();

            if (type === 'email' || $el.is('input[type="email"]')) {
                rules[name].email = true;
                if (selectedLang === 'tr') {
                    messages[name].email = "Lütfen geçerli bir e-posta adresi girin.";
                } else {
                    messages[name].email = "Please enter a valid email address.";
                }
            }

            if (name === 'phone' || $el.attr('id') === 'beerloyuz_phone') {
                rules[name].digits = true;
                rules[name].minlength = 10;
                rules[name].maxlength = 15;
                if (selectedLang === 'tr') {
                    messages[name].digits = "Telefon numarası sadece rakamlardan oluşmalıdır.";
                    messages[name].minlength = "Lütfen geçerli bir telefon numarası girin.";
                } else {
                    messages[name].digits = "Phone number should contain only numbers.";
                    messages[name].minlength = "Please enter a valid phone number.";
                }

            }

            // Ensure message field has a maximum length of 100 characters
            if (name === 'message' || $el.is('textarea[name="message"]') || $el.attr('id') === 'beerloyuz_message') {
                rules[name].maxlength = 100;
                if (selectedLang === 'tr') {
                    messages[name].maxlength = "Mesaj en fazla 100 karakter uzunluğunda olmalıdır.";
                } else {
                    messages[name].maxlength = "Message must be at most 100 characters long.";
                }
            }

            // Do not add minlength for the message field — it's optional
            if (name !== 'message' && ($el.is('textarea[name="message"]') || $el.attr('id') === 'beerloyuz_message')) {
                rules[name].minlength = 10;
                if(selectedLang === 'tr') {
                    messages[name].minlength = "Mesaj en az 10 karakter uzunluğunda olmalıdır.";
                } else {
                    messages[name].minlength = "Message must be at least 10 characters long.";
                }
            }
        });

        $form.validate({
            rules: rules,
            messages: messages,
            errorClass: 'beerloyuz-validation-error',
            errorElement: 'div',
            highlight: function (el) {
                $(el).addClass('beerloyuz-invalid');
            },
            unhighlight: function (el) {
                $(el).removeClass('beerloyuz-invalid');
            },
            submitHandler: function (formEl) {
                var honeyValue = $(".beerloyuz-blocks-mail-popup-honey").val();
                if (honeyValue && honeyValue.trim() !== "") {
                    $("#form_error").html("Spam detected.").fadeIn();
                    $("#form_success").hide();
                    return false; // Prevent submission
                }
                var $submitBtn = $form.find('button[type="submit"]').first();
                $submitBtn.prop('disabled', true).text(buttonSubmittingText).css({ "opacity": "0.6", "cursor": "not-allowed" });

                $.ajax({
                    type: "POST",
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    dataType: 'json',
                    beforeSend: function (xhr) {
                        if (nonce) {
                            xhr.setRequestHeader('X-WP-Nonce', nonce);
                        }
                    },
                    success: function (res, textStatus, jqXHR) {
                        // robust success detection: check common shapes, fall back to HTTP status
                        var ok = false;
                        if(selectedLang === 'tr'){
                            var message = 'Mesajınız başarıyla gönderildi.';
                        } else {
                            var message = 'Your message has been successfully sent.';
                        }
                        if (res && typeof res === 'object') {
                            if (res.success === true) {
                                ok = true;
                                message = res.message || message;
                            } else if (res.data && res.data.success === true) {
                                ok = true;
                                message = res.data.message || res.data || message;
                            } else if (res.message && (jqXHR.status >= 200 && jqXHR.status < 300)) {
                                // sometimes WP wraps response differently; assume success on 2xx with message
                                ok = (res.success !== false);
                                message = res.message || message;
                            }
                        } else {
                            ok = (jqXHR.status >= 200 && jqXHR.status < 300);
                        }

                        if (ok) {
                            $form.find("#form_success").html(message).fadeIn();
                            $form.find("#form_error").hide();
                            $form.trigger("reset");
                        } else {
                            // prefer server message when available
                            var errMsg = (res && res.message) ? res.message : 'Error sending message.';
                            $form.find("#form_error").html(errMsg).fadeIn();
                            $form.find("#form_success").hide();
                        }
                    },
                    error: function (xhr) {
                        var msg = 'Request failed.';
                        try {
                            var body = xhr.responseJSON || JSON.parse(xhr.responseText);
                            if (body && body.message) msg = body.message;
                        } catch (err) { }
                        $form.find("#form_error").html(msg).fadeIn();
                        $form.find("#form_success").hide();
                    },
                    complete: function () {
                        $submitBtn.prop('disabled', false).text(buttonText).css({ "opacity": "1", "cursor": "pointer" });
                    }
                });
            }
        });
    });
});